"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var ProjectEnactedIcon_1 = __importDefault(require("../../../Icons/Notifications/ProjectEnactedIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Congratulations!",
            ' ',
            react_1.default.createElement("a", { className: "dcl notification-link", href: link }, "Your Project"),
            ' ',
            "has been successfully enacted and a funding Vesting Contract was created.")); },
        title: 'Your Project has been funded'
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Felicitaciones!",
            ' ',
            react_1.default.createElement("a", { className: "dcl notification-link", href: link }, "Tu proyecto"),
            ' ',
            "ha sido aprobado y un Vesting Contract de financiamiento fue creado.")); },
        title: 'Su proyecto ha sido financiado'
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u606D\u559C\u60A8\uFF01",
            react_1.default.createElement("a", { className: "dcl notification-link", href: link }, "\u60A8\u7684\u9879\u76EE\u5DF2\u6210\u529F\u7ACB\u9879"),
            "\uFF0C\u5E76\u7B7E\u8BA2\u4E86\u8D44\u91D1\u5F52\u5C5E\u5408\u540C.")); },
        title: '您的项目已获得资助'
    }
};
var GovernanceProposalEnactedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(ProjectEnactedIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceProposalEnactedNotification;
